<template>
    <div id="square">
    <createIndex></createIndex>
        <div class="tab flex ">
            <div class="item"
                 :class="index==tab_active?'active':''"
                 @click="choose_tab(index)"
                 v-for="(item,index) in tab_list"
                 :key="index">{{item}}</div>
        </div>
        <div class="search">
            <el-input placeholder="请输入关键词"
                      class="keywords"
                      size="small"
                      prefix-icon="el-icon-search"
                      v-model="keywords" 
                      @keyup.enter="search">
            </el-input>
        </div>
        <div class="tags" flex-align>
            <div :class="item.id==cate_id?'active':''"
                  @click="choose_tag(item)"
                  v-for="(item,index) in cate_list"
                  :key="index">{{item.name}}</div>
        </div>
        <div class="tab_con">
            <div class="tab_draw"
                 v-if="water_draw_list.length">
                <waterfall ref="waterfall"
                           :col="2"
                           :width="fall_width"
                           :gutterWidth="10"
                           :data="water_draw_list"
                           @loadmore="loadmore_draw"
                           :height="'100%'">
                    <template>
                        <div class="cell_item"
                            @click="go(item)"
                             v-for="(item, index) in water_draw_list"
                             :key="index">
                            <img :src="item.img_url"
                                 class="pic" />
                        </div>
                    </template>
                </waterfall>
            </div>
            <empty v-else></empty>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import empty from '@/components/Empty'
import createIndex from "@/components/createIndex"
export default {
    components: { empty,createIndex },
    data () {
        return {
            tab_list: ['绘画广场'],
            tab_active: 0,
            fall_width:120,
            keywords: '',
            cate_list: [{
                id: 0,
                name: '全部',
                active:true
            }],
            tag_active: 0,
            water_draw_list: [],
            page: 1,
            water_video_list: [],
            max_mj_id:0,
            cate_id:0
        }
    },
    created () {
        // console.log(this.$route.path);
        document.onkeyup = e => {
            if (e.keyCode === 13) {
                // 调用登录 验证方法
                this.search()
            }
        }
        let screenWidth = document.documentElement.clientWidth;
        this.fall_width = (screenWidth - 30)/2;
        this.$http.get(`/front/aimj/draw/cate/`).then((res) => {
            let _list = res.data.item_list
            _list.forEach(e => {
                e.active = false
                
            });
            if(_list.length > 0)
                _list[0].active = true
            this.cate_list = this.cate_list.concat(_list)
        })
        this.get_draw_list()
    },
    methods: {
        //选择标签
        choose_tag (item) {
            this.water_draw_list = []
            this.max_mj_id = 0
            this.page = 1
            this.cate_id = item.id
            this.get_draw_list()
        },
        search(){
            this.water_draw_list = []
            this.page = 1;
            this.max_mj_id = 0;
            this.cate_id = 0;
            this.get_draw_list();
        },
        //获取绘画广场数据
        get_draw_list (tj_cate_id) {
            this.$http.get('/front/aimj/draw/index/', {params:{sys_cate_id:this.cate_id, keywords:this.keywords, page:this.page}}).then(res => {
                if (res.status == '200') {
                    if (res.data.item_list.length == 0) {
                        this.$message('没有更多了');
                    }else{
                    this.max_mj_id = res.data.item_list[res.data.item_list.length-1].draw_id
                    this.water_draw_list = this.water_draw_list.concat(res.data.item_list);
                    }
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        //绘画广场加载更多
        loadmore_draw () {
            this.page++;
            this.get_draw_list()
        },
        go (item) {
            this.$router.push('/drawDetail?draw_id=' + item.draw_id)
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#square {
    width: 100%;
    height: 100%;
    padding: 10px 10px 55px;
    // display: flex;
    // flex-direction: column;
    overflow-y: auto;
}
.tab {
    justify-content: center;
    margin: 10px 0 20px;
    .item {
        cursor: pointer;
        font-size: 22px;
        font-weight: bold;
        color: #949ba4;
        margin: 0 50px;
        position: relative;
        height: 35px;
        line-height: 35px;
        &.active {
            font-size: 26px;
            color: #fff;
            &:after {
                position: absolute;
                left: 0;
                bottom: 0;
                content: "";
                width: 100%;
                height: 5px;
                background: linear-gradient(
                    90deg,
                    #5865f2 0%,
                    rgba(88, 101, 242, 0) 99%
                );
            }
        }
    }
}
.search {
    width: 100%;
    margin: 0 auto 20px;
    .keywords {
        border: 2px solid #5865f2;
        background-color: transparent;
        border-radius: 30px;
        /deep/.el-input__inner {
            background-color: transparent;
            border: none;
            color: rgba(255, 255, 255, 0.78);
        }
    }
}
.tags {
    overflow-x: auto;
    padding-bottom: 5px;
    overflow-y: auto;
    &::-webkit-scrollbar {
        margin-left: 5px !important;
        display: block !important;
        height: 6px !important;
    }

    &::-webkit-scrollbar-thumb {
        height: 30px !important;
        background-color: #777 !important;
        border-radius: 10px !important;
    }
    div {
        cursor: pointer;
        font-size: 14px;
        color: #d8d9db;
        margin-right: 10px;
        padding: 0 16px;
        height: 26px;
        line-height: 26px;
        white-space: nowrap;
        &.active {
            background: #474e53;
            border-radius: 30px;
        }
    }
}
.tab_con {
    overflow: hidden;
    flex: 1 1 0%;
}
.tab_draw {
    overflow: hidden;
    height: 100%;
    margin: 10px 0;
    .cell_item {
        position: relative;
        overflow: hidden;
        border-radius: 10px;
        margin-bottom: 10px;

        .pic {
            overflow: hidden;
            border-radius: 10px;
            transition: all 0.4s;
            display: block;
        }
        &:hover {
            .pic {
                transform: scale(1.1);
            }
        }
    }
}
</style>